<template>
  <div class="py-2">
    <div class="row">
      <div class="col-12 mb-3">
        <em class="fas fa-info-circle text-orange mr-1" />
        <span>Información del Estudiante</span>
      </div>
      <div class="col-12 mx-4">
        <div class="row">
          <div class="col-sm">
            <span class="data-label">Impedimento:</span>
            <p class="data">{{ value.impediment || '-' }}</p>
          </div>
          <div class="col-sm">
            <span class="data-label">Escuela:</span>
            <p class="data">{{ value.schoolCode }} - {{ value.school }}</p>
          </div>
        </div>
      </div>
      <div class="col-12 mb-3">
        <em class="fas fa-info-circle text-orange mr-1" />
        <span>Información de Servicio</span>
      </div>
      <div class="col-12 mx-4">
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Desde:</span>
            <p class="data">{{ value.dateFrom | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Inicial:</span>
            <p class="data">{{ value.initialDate | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Proveedor:</span>
            <p class="data">{{ value.providerName || '-' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Hasta:</span>
            <p class="data">{{ value.dateTo | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Admisión:</span>
            <p class="data">{{ value.admissionDate | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Lugar de Servicio:</span>
            <p class="data">{{ value.locationName || '-' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Referido:</span>
            <p class="data">{{ value.referralDate | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Última visita:</span>
            <p class="data">{{ value.lastDateVisit | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Especialista de Admisión:</span>
            <p class="data">{{ value.admissionSpecialist || '-' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Vinculado:</span>
            <p class="data">{{ value.linkedDate | date }}</p>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Contacto:</span>
            <p class="data">
              <label>
                {{ value.contact }}
                <br />
                {{ value.contactTelephone }}
                <br />
                {{ value.contactEmail }}
              </label>
            </p>
          </div>
          <div v-if="!hasPilotPermission" class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">
              Especialista de Servicio Asignado:
            </span>
            <p class="data">{{ value.serviceSpecialist || '-' }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-6 col-lg-3">
            <span class="data-label">Tipo de Referido:</span>
            <p class="data">{{ value.admissionCreationReason }}</p>
          </div>
        </div>
      </div>
      <div v-if="hasPilotPermission" class="container-fluid">
        <div class="col-12 mb-3">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span>Lugar de Servicio donde se recibirá el servicio</span>
        </div>
        <div>
          <div class="row pl-4">
            <div class="col-sm-12 col-md-6 col-lg-2">
              <span class="data-label">Tipo de Lugar:</span>
              <p class="data">{{ value.locationTypeName || '-' }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2 ml-3">
              <span class="data-label">Municipio:</span>
              <p class="data">{{ value.municipality || '-' }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <span class="data-label">Región:</span>
              <p class="data">{{ value.region || '-' }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-2">
              <span class="data-label">Escuela:</span>
              <p class="data">
                {{ value.schoolCode || '-' }} - {{ value.school }}
              </p>
            </div>
          </div>
          <div class="row pl-4">
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">
                Especialista de Servicio Asignado:
              </span>
              <p class="data">{{ value.serviceSpecialist || '-' }}</p>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3">
              <span class="data-label">Practicante:</span>
              <p class="data">{{ value.practitioner || '-' }}</p>
            </div>
          </div>
          <div class="row pl-4">
            <label class="data-label col-md-12">Día/Hora:</label>
            <div
              v-for="day in value.serviceDays"
              :key="day.id"
              class="col-sm-12 col-md-6 col-lg-2"
              style="display: inline-block;"
            >
              <span class="data">{{ formatToWeekDay(day.day) }}:</span>
              <p class="data font-weight-bold">
                {{ formatHours(day.starDate, day.endTime) }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mx-4">
        <span class="data-label">Razón de Servicio:</span>
        <p class="data">{{ value.serviceReason | empty }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import 'moment/locale/es';
import admissionStatus from '@/utils/shared/constants/admissionStatus';

export default {
  name: 'InformationDetail',
  props: {
    value: { type: Object, default: () => ({}) },
    hasPilotPermission: { type: Boolean, default: () => false },
  },
  methods: {
    formatToWeekDay(weekOfDay) {
      moment.locale('es');
      let formatedDate = moment.weekdays(weekOfDay);
      formatedDate = formatedDate[0].toUpperCase() + formatedDate.substring(1);
      return formatedDate;
    },

    formatHours(starDate, endDate) {
      starDate = new Date(starDate);
      endDate = new Date(endDate);
      const options = { hour: '2-digit', minute: '2-digit' };
      starDate = starDate.toLocaleString('en-US', options);
      endDate = endDate.toLocaleString('en-US', options);
      return starDate + ' - ' + endDate;
    },

    isAdmited() {
      return this.value.statusId == admissionStatus.Admitido;
    },
  },
};
</script>
